// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__r17sx","margin-10":"Sidebar_margin-10__+YUM3"};